import { LoginResponse, OnboardingQuestionType } from "../models/types";
import { httpPostAuthenticated } from "./Api";

const endpoints = {
    answer_question: () => "/central/onboarding",
};

export const answerOnboardingQuestion = async (payload: {
    question: OnboardingQuestionType;
    answer: string;
}) => {
    return httpPostAuthenticated<LoginResponse>(endpoints.answer_question(), payload);
}